module.exports = __webpack_public_path__ + "img/btn_income_green.1f21485e.svg";